import { Box, BoxProps } from "@mui/material"
import { DAMS_SIDE_DRAWER_WIDTH } from "../components/styles/common"


function SideBarOutletContainer({ children }: BoxProps) {
    return (
        <Box
            // border={'2px solid blue'}
            width={`calc(100% - ${DAMS_SIDE_DRAWER_WIDTH}px)`}
            ml={`${DAMS_SIDE_DRAWER_WIDTH}px`}
            height={'100vh'}>
            {children}
        </Box>
    )
}


export { SideBarOutletContainer }
